module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2n7r4r-ba26be8a72d1319c8157ba1e23193851.svg";